export default {
  //存储token令牌
  storeToken(data) {
    window.localStorage.setItem('token', data.token)
  },

  fetchToken() {
    return window.localStorage.getItem('token') || ''
  },

  clearToken() {
    window.localStorage.removeItem('token')
  },
// 获取本地缓存OSS路径
  fetchOssConfig() {
    return window.localStorage.getItem('admin-ossConfig');
  },
// 本地缓存OSS路径
  storeOssConfig(data) {
    window.localStorage.setItem('admin-ossConfig', data);
  },
  //存储用户信息
  storeUserInfo(data) {
    window.localStorage.setItem('userInfo', JSON.stringify(data))
    // window.localStorage.setItem('popInfo', JSON.stringify(data))
  },

  storeLedgerStep(step) {
    window.localStorage.setItem('step', step)
  },

  fetchLedgerStep() {
    return window.localStorage.getItem('step');
  },

  storeLedgerUser(data) {
    window.localStorage.setItem('ledger', JSON.stringify(data))
  },

  fetchUserInfo(key) {
    // return JSON.parse(window.localStorage.getItem('userInfo') || '')
    return JSON.parse(window.localStorage.getItem(key) || '')
  },

  clearUserInfo(key) {
    // window.localStorage.removeItem('userInfo')
    window.localStorage.removeItem(key)
  },

}



// WEBPACK FOOTER //
// ./src/utility/cache.js